import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import { useLocalStorageState } from 'hooks/use-local-storage-state';
import { StorageKeys } from 'utils/local-storage';

import {
  ActionButtonContainer,
  MockedSelectorDate,
  MockedSelectorTitle,
  TimeSelector,
} from './pick-future-time-modal.styled';
import { IPickFutureTimeModalProps } from './types';

export const PickFutureTimeModal: React.FC<IPickFutureTimeModalProps> = ({
  isOpen,
  onClose,
  onPickupTimeCallback,
}) => {
  const { formatMessage } = useIntl();

  const [futureOrderTime, setFutureOrderTime] = useLocalStorageState<boolean | null>({
    key: StorageKeys.TEMP_FUTURE_ORDERING_TIME,
    defaultReturnValue: false,
  });

  const today = new Date();
  const todayDateText = today.toLocaleDateString(formatMessage({ id: 'localeDateTime' }), {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const tomorrowDateText = tomorrow.toLocaleDateString(formatMessage({ id: 'localeDateTime' }), {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <ActionsheetWrapper
      onOpenEventMessage="Pickup schedule order time"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ActionsheetContent width="full">
        <TimeSelector
          $isSelected={!futureOrderTime}
          onPress={() => {
            setFutureOrderTime(false);
          }}
        >
          <MockedSelectorTitle>
            <Text>{formatMessage({ id: 'today' })}</Text>
          </MockedSelectorTitle>
          <MockedSelectorDate>
            <Text>{todayDateText}</Text>
            <Text>{formatMessage({ id: 'asap' })}</Text>
          </MockedSelectorDate>
        </TimeSelector>

        <TimeSelector
          $isSelected={!!futureOrderTime}
          onPress={() => {
            setFutureOrderTime(true);
          }}
        >
          <MockedSelectorTitle>
            <Text>{formatMessage({ id: 'tomorrow' })}</Text>
          </MockedSelectorTitle>
          <MockedSelectorDate>
            <Text>{tomorrowDateText}</Text>
            <Text>
              {today.toLocaleTimeString(formatMessage({ id: 'localeDateTime' }), {
                hour12: true,
                minute: 'numeric',
                hour: 'numeric',
              })}
            </Text>
          </MockedSelectorDate>
        </TimeSelector>

        <ActionButtonContainer>
          <ActionButton onPress={onPickupTimeCallback} width="full">
            {formatMessage({ id: 'startYourOrder' })}
          </ActionButton>
        </ActionButtonContainer>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
